<template>
  <oil-form v-if="loading"
            :title="title.toUpperCase()"
            :createForm="!id"
            :keys="keys"
            :items="driver"
            :formCallback="formCallback"
  />

</template>

<script>
import keys from './setting/driver.json'
import {driverService} from "@/services/DriverSerivce";
import {vehicleService} from "@/services/VehicleService";
import {userService} from "~/services/userService";

export default {
  props: {
    id: String
  },
  data: () => ({
    keys: keys,
    loading: false,
    title: 'создать водителя',
    driver: {
      Name: '',
      Number: '',
      Status: 'active',
    },
    users: [],
    vehicles: [],
  }),
  components: {
    OilForm: () => import('@/components/helper/oil.form')
  },
  async created() {
    const vehicles = await vehicleService.getAll({isOwn: true})
    this.vehicles = vehicles.data
    const roles = await userService.getByRole()
    this.users = roles.data
    if (this.id) {
      this.title = 'ИНФО ВОДИТЕЛЯ'
      const driver = await driverService.getById(this.id)
      this.driver = driver.data
    }
    this.loading = true
  },
  computed: {
    storeType() {
      return this.id ? driverService.update : driverService.create
    }
  },
  methods: {
    async formCallback(data, input) {

      input.isEdit = false

      const driver = await this.storeType(data)
      const id = driver?.data?.Id

      if (!id) {
        input.isEdit = true
        return
      }

      this.driver.Id = driver.data.Id
      this.driver = driver.data

      if (!this.id) {
        await this.$router.replace({
          path: `/driver/${this.driver.Id}`,
          replace: true
        })
        this.title = 'ИНФО ВОДИТЕЛЯ'
      }

    }
  },
  watch: {
    vehicles(vehicles) {
      this.keys.VehicleId.attrs.items = vehicles
    },
    users(users) {
      this.keys.AccountId.attrs.items = users
    }
  }
}
</script>